export default "__VITE_ASSET__c275cde4__"